/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../../../graphql.generated'

const defaultOptions = {} as const
export type GetIntakeNoteComprehensivePatientDataQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetIntakeNoteComprehensivePatientDataQuery = {
  __typename?: 'Query'
  intakeNoteComprehensivePatientData: {
    __typename?: 'IntakeNoteComprehensivePatientData'
    id: string
    overallInformation?: {
      __typename?: 'IntakeNoteComprehensiveOverallInformation'
      firstName?: string | null
      lastName?: string | null
      memberID?: string | null
      callStartTime?: string | null
      callEndTime?: string | null
      providerName?: string | null
      licenseType?: string | null
    } | null
    healthQuestionnaire?: {
      __typename?: 'IntakeNoteComprehensiveHealthQuestionnaire'
      phq9?: {
        __typename?: 'HealthQuestionnairePHQ9'
        PHQ9_QUESTION_1?: number | null
        PHQ9_QUESTION_2?: number | null
        PHQ9_QUESTION_3?: number | null
        PHQ9_QUESTION_4?: number | null
        PHQ9_QUESTION_5?: number | null
        PHQ9_QUESTION_6?: number | null
        PHQ9_QUESTION_7?: number | null
        PHQ9_QUESTION_8?: number | null
        PHQ9_QUESTION_9?: number | null
        PHQ9_SCORE?: number | null
      } | null
      gad7?: {
        __typename?: 'HealthQuestionnaireGAD7'
        GAD7_QUESTION_1?: number | null
        GAD7_QUESTION_2?: number | null
        GAD7_QUESTION_3?: number | null
        GAD7_QUESTION_4?: number | null
        GAD7_QUESTION_5?: number | null
        GAD7_QUESTION_6?: number | null
        GAD7_QUESTION_7?: number | null
        GAD7_SCORE?: number | null
      } | null
    } | null
    patientAnswers?: {
      __typename?: 'IntakeNoteComprehensivePatientAnswer'
      id: string
      createdAt?: Date | null
      data: {
        __typename?: 'PatientAnswerData'
        currentLivingSituation?: string | null
        hasAllergies?: boolean | null
        listAllergies?: string | null
        functionalImpairments?: Array<string> | null
        medicalHistory?: Array<string> | null
        otherConditions?: string | null
        doctorName?: string | null
        doctorPhoneNumber?: string | null
        takesMedication?: boolean | null
        alcohol?: string | null
        marijuana?: string | null
        supportDetails?: string | null
        nonprescriptionDrugs?: string | null
        substanceUseSupport?: Array<string> | null
        tobaccoCigarettesChewVape?: string | null
        otherRecreationalSubstances?: string | null
        mentalIllnessHistoryInFamily?: boolean | null
        mentalIllnessDiagnosisFamily?: Array<string> | null
        hasSeenAMentalHealthProfessional?: boolean | null
        detailsOfExperienceWithMentalHealthProfessional?: string | null
        hasBeenHospitalized?: boolean | null
        detailsOfHospitalization?: string | null
        mainReasonForSeekingSupport?: string | null
        medications?: Array<{
          __typename?: 'PatientAnswerMedication'
          name?: string | null
          dosage?: string | null
          frequency?: string | null
        }> | null
      }
    } | null
  }
}

export type PatientAnswerDataTypeFragment = {
  __typename?: 'PatientAnswerData'
  currentLivingSituation?: string | null
  hasAllergies?: boolean | null
  listAllergies?: string | null
  functionalImpairments?: Array<string> | null
  medicalHistory?: Array<string> | null
  otherConditions?: string | null
  doctorName?: string | null
  doctorPhoneNumber?: string | null
  takesMedication?: boolean | null
  alcohol?: string | null
  marijuana?: string | null
  supportDetails?: string | null
  nonprescriptionDrugs?: string | null
  substanceUseSupport?: Array<string> | null
  tobaccoCigarettesChewVape?: string | null
  otherRecreationalSubstances?: string | null
  mentalIllnessHistoryInFamily?: boolean | null
  mentalIllnessDiagnosisFamily?: Array<string> | null
  hasSeenAMentalHealthProfessional?: boolean | null
  detailsOfExperienceWithMentalHealthProfessional?: string | null
  hasBeenHospitalized?: boolean | null
  detailsOfHospitalization?: string | null
  mainReasonForSeekingSupport?: string | null
  medications?: Array<{
    __typename?: 'PatientAnswerMedication'
    name?: string | null
    dosage?: string | null
    frequency?: string | null
  }> | null
}

export const PatientAnswerDataTypeFragmentDoc = gql`
  fragment PatientAnswerDataType on PatientAnswerData {
    currentLivingSituation
    hasAllergies
    listAllergies
    functionalImpairments
    medicalHistory
    otherConditions
    doctorName
    doctorPhoneNumber
    takesMedication
    medications {
      name
      dosage
      frequency
    }
    alcohol
    marijuana
    supportDetails
    nonprescriptionDrugs
    substanceUseSupport
    tobaccoCigarettesChewVape
    otherRecreationalSubstances
    mentalIllnessHistoryInFamily
    mentalIllnessDiagnosisFamily
    hasSeenAMentalHealthProfessional
    detailsOfExperienceWithMentalHealthProfessional
    hasBeenHospitalized
    detailsOfHospitalization
    mainReasonForSeekingSupport
  }
`
export const GetIntakeNoteComprehensivePatientDataDocument = gql`
  query getIntakeNoteComprehensivePatientData($uid: ID!) {
    intakeNoteComprehensivePatientData(uid: $uid) {
      id
      overallInformation {
        firstName
        lastName
        memberID
        callStartTime
        callEndTime
        providerName
        licenseType
      }
      healthQuestionnaire {
        phq9 {
          PHQ9_QUESTION_1
          PHQ9_QUESTION_2
          PHQ9_QUESTION_3
          PHQ9_QUESTION_4
          PHQ9_QUESTION_5
          PHQ9_QUESTION_6
          PHQ9_QUESTION_7
          PHQ9_QUESTION_8
          PHQ9_QUESTION_9
          PHQ9_SCORE
        }
        gad7 {
          GAD7_QUESTION_1
          GAD7_QUESTION_2
          GAD7_QUESTION_3
          GAD7_QUESTION_4
          GAD7_QUESTION_5
          GAD7_QUESTION_6
          GAD7_QUESTION_7
          GAD7_SCORE
        }
      }
      patientAnswers {
        id
        createdAt
        data {
          ...PatientAnswerDataType
        }
      }
    }
  }
  ${PatientAnswerDataTypeFragmentDoc}
`

/**
 * __useGetIntakeNoteComprehensivePatientDataQuery__
 *
 * To run a query within a React component, call `useGetIntakeNoteComprehensivePatientDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntakeNoteComprehensivePatientDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntakeNoteComprehensivePatientDataQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetIntakeNoteComprehensivePatientDataQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetIntakeNoteComprehensivePatientDataQuery,
    GetIntakeNoteComprehensivePatientDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetIntakeNoteComprehensivePatientDataQuery,
    GetIntakeNoteComprehensivePatientDataQueryVariables
  >(GetIntakeNoteComprehensivePatientDataDocument, options)
}
export function useGetIntakeNoteComprehensivePatientDataLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetIntakeNoteComprehensivePatientDataQuery,
    GetIntakeNoteComprehensivePatientDataQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetIntakeNoteComprehensivePatientDataQuery,
    GetIntakeNoteComprehensivePatientDataQueryVariables
  >(GetIntakeNoteComprehensivePatientDataDocument, options)
}
export type GetIntakeNoteComprehensivePatientDataQueryHookResult = ReturnType<
  typeof useGetIntakeNoteComprehensivePatientDataQuery
>
export type GetIntakeNoteComprehensivePatientDataLazyQueryHookResult = ReturnType<
  typeof useGetIntakeNoteComprehensivePatientDataLazyQuery
>
export type GetIntakeNoteComprehensivePatientDataQueryResult = Apollo.QueryResult<
  GetIntakeNoteComprehensivePatientDataQuery,
  GetIntakeNoteComprehensivePatientDataQueryVariables
>
